import React, { Suspense } from 'react';
import ReactHtmlParser from 'react-html-parser';
import { upsellbanner, proceedToCheckoutForRAF, proceedToCheckoutForFF, proceedToCheckoutForVZC, getServiceType, addEquipment, getOffersFilter, updateCart, upSellCTA, suppressinter, suppressinterinvoke, removeUnSelectedManualOffers } from './../../action/buildProduct';
import { connect } from 'react-redux';
import { ModalWindow, ProductType, Service, OfferTypes } from './../../constants/actionType';
import ModalOverlay from './../../components/modalOverlay';
import { closeModalWindow } from './../../action/modalWindow';
import { updateSCTags } from './../../service/dtmTag';
import { getSelectedTv } from './../../util/cartUtility';
import { InHomeUtils } from './../../util/inhomeUtils';
import ConditionIcon from '@vds/icons/condition-based-wrench';
import FleetTracking from '@vds/icons/fleet-tracking';
import SmartCommunities from '@vds/icons/smart-communities';
import SupportDrawer from '@vds/icons/support-drawer';
import Reminder from '@vds/icons/reminder';
import ReactTooltip from "react-tooltip";
import { Title, Micro } from '@vds/typography';
import { Button } from '@vds/buttons';
import { Body } from '@vds/typography';
import { TitleLockup } from '@vds/type-lockups';
import { UnorderedList, ListItem } from '@vds/lists';
import { ModalTitle, ModalBody } from '@vds/modals';
import { Accordion, AccordionItem, AccordionHeader, AccordionDetail, AccordionTitle} from '@vds/accordions';
import {getCmsData} from '../midnight/services/dataFormatter';
import { updatePerkSelection } from "../../action/buildProduct";
import { detectClient } from '../../util/detectClient';
import {  setAccordionStatus} from './../../action/buildProduct';
const LazyImage = React.lazy(() => import("../../components/lazyImage"));
const images = {
  laptopImage: require("./../../assets/ak-cached/24h/img/accV2/Laptop.png")
    .default,
  tvImage: require("./../../assets/ak-cached/24h/img/accV2/TV.png").default,
};
import GiftIcon from '@vds/icons/gift';
import { Line } from '@vds/lines';
import Download from '@vds/icons/download';
import HomeInternet from '@vds/icons/home-internet';
import NoFee from '@vds/icons/no-fee';
import LockClosed from '@vds/icons/lock-closed';
import SpeedMonitoring from '@vds/icons/speed-monitoring';
import Tv from '@vds/icons/tv';
import TopBox from '@vds/icons/top-box';
import CrossDevice from '@vds/icons/cross-device';
import Pause from '@vds/icons/pause';
import FindMyRemote from '@vds/icons/find-my-remote';

class upsell extends React.PureComponent {
    constructor(props) {
        super(props);
        this.isReskin = this.props.buildProductState.isReskin && this.props.lqState && this.props.lqState.runtimeKey && this.props.lqState.runtimeKey.EnableReskin === 'Y';
    }
    getProduct = (upsellProdType) => {
        if(upsellProdType.prodType && upsellProdType.identifier) {
            let product = null;
            switch(upsellProdType.prodType.toUpperCase()) {
                case 'PPP' :  product = this.props.buildProduct && this.props.buildProduct.techsure && !this.props.buildProduct.techsure.selectectProduct ? this.props.buildProduct && this.props.buildProduct.techsure && this.props.buildProduct.techsure.techsureProducts && this.props.buildProduct.techsure.techsureProducts.filter(p => p.name && p.name.toUpperCase() === upsellProdType.identifier.toUpperCase()) : null;
                break;
                default: break;
            }
            return product && product.length ? product[0] : null;
        }
    }

    addmnhUpsell =() =>{
        upsellbanner(true,this.props.dispatch);
        closeModalWindow("UPSELL", this.props.dispatch);       
        updateSCTags("request callback - upsell vzw unlimited");
        let isProceedToCheckoutForRAF = true;    
        let isProceedToCheckoutForFF = true;
        let isProceedToCheckoutForVZC = true;
        let proceedToCheckout=true;
        if(InHomeUtils.isNotNull(this.props.buildProduct.couponInfo.coupon) && InHomeUtils.isNotEmpty(this.props.buildProduct.couponInfo.coupon)  && this.props.buildProduct.couponInfo.referfriendvalidationsucess)            
        isProceedToCheckoutForRAF=proceedToCheckoutForRAF(this.props.visitId,this.props.lqState,this.props.buildProduct,this.props.cart,this.props.dispatch)? true :false;                 
        else if(InHomeUtils.isNotNull(this.props.buildProduct.ffCouponInfo.ffCoupon) && InHomeUtils.isNotEmpty(this.props.buildProduct.ffCouponInfo.ffCoupon) && this.props.buildProduct.ffCouponInfo.ffValidationSucess)
        isProceedToCheckoutForFF=proceedToCheckoutForFF(this.props.visitId,this.props.lqState,this.props.buildProduct,this.props.cart,this.props.dispatch)? true :false;                 
        else if (InHomeUtils.isNotNull(this.props.buildProduct) && InHomeUtils.isNotNull(this.props.buildProduct.vzcCouponInfo) && InHomeUtils.isNotNull(this.props.buildProduct.vzcCouponInfo.vzcValidationSuccess) && this.props.buildProduct.vzcCouponInfo.vzcValidationSuccess)
        isProceedToCheckoutForVZC = proceedToCheckoutForVZC(this.props.buildProduct, this.props.lqState, this.props.dispatch) ? true : false;
        if ((isProceedToCheckoutForRAF && InHomeUtils.isNotNull(this.props.buildProduct.couponInfo.coupon) && InHomeUtils.isNotEmpty(this.props.buildProduct.couponInfo.coupon)  && this.props.buildProduct.couponInfo.referfriendvalidationsucess) || (isProceedToCheckoutForFF && InHomeUtils.isNotNull(this.props.buildProduct.ffCouponInfo.ffCoupon) && InHomeUtils.isNotEmpty(this.props.buildProduct.ffCouponInfo.ffCoupon) && this.props.buildProduct.ffCouponInfo.ffValidationSucess) || (isProceedToCheckoutForVZC && InHomeUtils.isNotNull(this.props.buildProduct) && InHomeUtils.isNotNull(this.props.buildProduct.vzcCouponInfo) && InHomeUtils.isNotNull(this.props.buildProduct.vzcCouponInfo.vzcValidationSuccess) && this.props.buildProduct.vzcCouponInfo.vzcValidationSuccess)) {

            proceedToCheckout=true;
        }
        else if(!isProceedToCheckoutForRAF||! isProceedToCheckoutForFF || !isProceedToCheckoutForVZC)
        {
                    proceedToCheckout=false;
        }
        if (proceedToCheckout) {
            this.props.checkout();
        }
    }
    
    scrollToFccVideo =(element)=> {
        let focusElem = document.getElementById("focusTV")
        setTimeout(()=>{
            focusElem?.focus()
        },1000)
    }
    scrollToTop = (element)=>{
        setTimeout(()=>{
            setAccordionStatus(element, this.props.dispatch,false)
        },9000)
      }
    scrollToFccVoice =(element)=> {
        let focusElem = document.getElementById("focusPhone")
        setTimeout(()=>{
            focusElem?.focus()
        },1000)
    }
    addUpsellToCart = (showDataOffers, showVideoOffers, showVoiceOffers,speedCode, upsellProdType) => {
        const  isClassicalFlow  = !this.props?.buildProductState?.mnFromApi; 
        const displayUpsellModalReskin = this.props?.lqState && this.props?.lqState?.runtimeKey && this.props?.lqState?.runtimeKey?.upsellModalReskin && this.props?.lqState?.runtimeKey?.upsellModalReskin === "Y" && this.props?.appState?.flowType!='MV' && this.props?.appState?.flowType!='SUPP' && !isClassicalFlow;
        let upsellHeaderText = this.props.buildProduct.upsell.header;
        let upsellSCTag =(upsellHeaderText?.indexOf("Fios Home Phone") > -1 ||  !displayUpsellModalReskin)? this.buildSCContent("ATC","addToCart",speedCode):this.buildSCContent("UT","UpgradeToday",speedCode);
        let cartProd = upsellProdType ? this.getProduct(upsellProdType) : this.props.buildProduct.upsell.products.filter(prod => prod.display)[0];//this.props.buildProduct.upsell.products[0];
        if(cartProd.id==="R3583"){
            cartProd.name = "1 Gig"
        }
        const isDisneyPromoPresent = cartProd?.specialOffers?.find(offer => offer?.BsOfferAttrValue === 'DISNEY_BUNDLE_PERK_DISCOUNT');
        const isNetmaxPromo = cartProd?.specialOffers?.find(offer => offer?.BsOfferAttrValue === 'NETMAX_PERK_DISCOUNT' || offer?.BsOfferAttrValue === 'FIOS_XBOX_BUNDLE_HEADSET_CONTROLLER');
        let serviceType = getServiceType(cartProd.prodType);
        let selectedCoreServices = (InHomeUtils.isNotNull(this.props.cart) && InHomeUtils.isNotNull(this.props.cart.cartOrderDetail) && InHomeUtils.isNotNull(this.props.cart.cartOrderDetail.servicesOrdered)) ? this.props.cart.cartOrderDetail.servicesOrdered : '';
        let addonProduct={
            productInCart:[],
            isRemoved:[],
            prodType:[]
        }
        if(this.props.lqState && !this.props.lqState.isFCPflow && this.props.buildProduct.upsell.bundleKey === 'FTTP_1000M_1000M' && InHomeUtils.isNotNull(this.props.buildProduct.router.equipments)){  
            addEquipment(Service.router, addonProduct, false, this.props.buildProduct);
        }
        if(!upsellProdType && this.props.lqState && this.props.lqState.isFCPflow && InHomeUtils.isNotNull(this.props.buildProduct.upsell.equipmentOffers) && this.props.buildProduct.upsell.equipmentOffers.length > 0) {
            let addonEquipTypes = [...new Set(this.props.buildProduct.upsell.equipmentOffers.map(p => {return p.split(':')[1]}))];
            addonEquipTypes.forEach(discount => {
                addEquipment(discount, addonProduct, false, this.props.buildProduct);
            })
        }
        let upsellInfo = {
            isUpsell : true, 
            upsellProducts : this.props.buildProduct.upsell.products, 
            upsellSCTag : upsellSCTag, 
            cart : this.props.cart,
            isUpsellAddonProduct : InHomeUtils.isNotNull(addonProduct.productInCart) && addonProduct.productInCart.length > 0,
            redirectToCheckout : true,
            upsellAddonProduct : addonProduct.productInCart
        };
        if(showDataOffers){
            if(this.props.buildProduct && !this.props.buildProduct.selectedCoreServices.includes("DATA")){
                upsellInfo.redirectToCheckout = false;
            }
            else if(this.props.lqState.runtimeKey.isAllowXboxOffer === "Y" && upsellInfo &&  upsellInfo.upsellProducts && upsellInfo.upsellProducts.length) {
                this.props.dispatch({type: 'FLASHOFFER_SELECTEDPRODID', value: null})
             let is1gigupsell =  upsellInfo.upsellProducts.map(p =>p.downSpeed && p.downSpeed ==="1024M");
                if(is1gigupsell && is1gigupsell.length >0){
                upsellInfo.redirectToCheckout = false;
                }
                
            }
        }
        if(showVideoOffers){
            if(this.props.buildProduct && !this.props.buildProduct.selectedCoreServices.includes("VIDEO")){
                upsellInfo.redirectToCheckout = true;
                this.scrollToFccVideo();
            }
        }
        if(showVoiceOffers){
            if( this.props.buildProduct && !this.props.buildProduct.selectedCoreServices.includes("VOICE")){
                upsellInfo.redirectToCheckout = false;
                this.scrollToFccVoice();
                this.scrollToTop("toggle_phone_accor")
            }
        }
        if(!upsellProdType && this.props.buildProduct && InHomeUtils.isNotNull(this.props.buildProduct.upsell.offers) && this.props.buildProduct.upsell.offers.length > 0 ) {
            if(!this.props.lqState.showStadia) {
                let splOfferChoices = this.props.buildProduct?.upsell?.offers?.filter(offer => getOffersFilter(offer,'DATA'))
                if(splOfferChoices.length > 1) {
                    if(!showVideoOffers)
                    upsellInfo.redirectToCheckout = false
                }
                else{
                    upsellInfo.redirectToCheckout = true;
                }
            }
        }

        if(isDisneyPromoPresent || isNetmaxPromo) {
            // after false need to redirect to specialoffer accordion
            upsellInfo.redirectToCheckout = false;
            // setTimeout(() => {
            //     this.props.dispatch({ type: 'TOGGLE_PERKS_ACCOR', value: true });
            // }, 1500);
        }

        updateCart(this.props.visitId,  this.props.lqState, cartProd, serviceType, false, this.props.dispatch, '', '',addonProduct, this.props.buildProduct.upsell.contract, selectedCoreServices, false, false, upsellInfo, this.props.buildProduct, this.props.buildProduct.loadedEquipments,this.props.appState.flowType);

        // updateSCTags("checkout");
    }

    updateSelectedPerk = async () =>{ 
        let upsellSCTag = this.buildSCContent("ATC","addToCart",'1024');
        let isMnHAuthenticated = ''
        let fromUpsell = true
        if(this.props.buildProduct?.internet?.mnhSignupIndicator !== "" && this.props.buildProduct?.internet?.mnhSignupIndicator !== null && this.props.buildProduct?.internet?.mnhSignupIndicator !== undefined) {
            isMnHAuthenticated = this.props.buildProduct?.internet?.mnhSignupIndicator
          }
        let add = true;
        let perselectedPerks = this.props.buildProduct?.perks?.plans
        let selectedPerkss = this.props?.cart?.cartData[0]?.perks?.perks
        let product = selectedPerkss?.find(data => (data.accordionTitle === 'Home Device Advisor'))
        let prodId = product?.prodId;
        let flowType = this.props.appState.flowType
        let visitId = this.props.visitId
        let dispatch = this.props.dispatch
        if(prodId) {
            await updatePerkSelection({product,prodId, add, flowType, visitId, dispatch, isMnHAuthenticated})
        }
        add = false;
        product = perselectedPerks?.find(data => (data.price === '25' && data.name === 'Verizon Home Device Protect'))
        prodId = product.productId;
        await updatePerkSelection({product,prodId, add, flowType, visitId, dispatch, isMnHAuthenticated,fromUpsell , checkoutClick : this.props.checkout })
       
    }

    noThanks = (cta,speedCode) => {
        this.buildSCContent(cta,"noThanks",speedCode);
        upSellCTA(this.props.dispatch, { isUpsellAddedToCart: false, isUpsellDenied: true });
        closeModalWindow("UPSELL", this.props.dispatch);       
        let isProceedToCheckoutForRAF = true;    
        let isProceedToCheckoutForFF = true;
        let isProceedToCheckoutForVZC = true;
        let proceedToCheckout=true;
        if(InHomeUtils.isNotNull(this.props.buildProduct.couponInfo.coupon) && InHomeUtils.isNotEmpty(this.props.buildProduct.couponInfo.coupon)  && this.props.buildProduct.couponInfo.referfriendvalidationsucess)            
        isProceedToCheckoutForRAF=proceedToCheckoutForRAF(this.props.visitId,this.props.lqState,this.props.buildProduct,this.props.cart,this.props.dispatch)? true :false;                 
        else if(InHomeUtils.isNotNull(this.props.buildProduct.ffCouponInfo.ffCoupon) && InHomeUtils.isNotEmpty(this.props.buildProduct.ffCouponInfo.ffCoupon) && this.props.buildProduct.ffCouponInfo.ffValidationSucess)
        isProceedToCheckoutForFF=proceedToCheckoutForFF(this.props.visitId,this.props.lqState,this.props.buildProduct,this.props.cart,this.props.dispatch)? true :false;                 
        else if (InHomeUtils.isNotNull(this.props.buildProduct) && InHomeUtils.isNotNull(this.props.buildProduct.vzcCouponInfo) && InHomeUtils.isNotNull(this.props.buildProduct.vzcCouponInfo.vzcValidationSuccess) && this.props.buildProduct.vzcCouponInfo.vzcValidationSuccess)
        isProceedToCheckoutForVZC = proceedToCheckoutForVZC(this.props.buildProduct, this.props.lqState, this.props.dispatch) ? true : false;
        if ((isProceedToCheckoutForRAF && InHomeUtils.isNotNull(this.props.buildProduct.couponInfo.coupon) && InHomeUtils.isNotEmpty(this.props.buildProduct.couponInfo.coupon)  && this.props.buildProduct.couponInfo.referfriendvalidationsucess) || (isProceedToCheckoutForFF && InHomeUtils.isNotNull(this.props.buildProduct.ffCouponInfo.ffCoupon) && InHomeUtils.isNotEmpty(this.props.buildProduct.ffCouponInfo.ffCoupon) && this.props.buildProduct.ffCouponInfo.ffValidationSucess) || (isProceedToCheckoutForVZC && InHomeUtils.isNotNull(this.props.buildProduct) && InHomeUtils.isNotNull(this.props.buildProduct.vzcCouponInfo) && InHomeUtils.isNotNull(this.props.buildProduct.vzcCouponInfo.vzcValidationSuccess) && this.props.buildProduct.vzcCouponInfo.vzcValidationSuccess)) {

            proceedToCheckout=true;
        }
        else if(!isProceedToCheckoutForRAF||! isProceedToCheckoutForFF || !isProceedToCheckoutForVZC)
        {
                    proceedToCheckout=false;
        }
        if (proceedToCheckout) {
            this.props.checkout();
        }        
        // updateSCTags("checkout");
    }
    updateMnhUpsellSCTags = (type) => {
        if (type === "noThanks") {
            if (this.props.lqState.vzwOffer.indexOf("VZWBONUSOFFERELIGIBLE:Y") === -1 && this.props.lqState.lqResponse.wirelessPlanType === 'UNLIMITED') {
                updateSCTags('upgrade-save10-no thanks');
            } else if (this.props.lqState.vzwOffer.indexOf("VZWBONUSOFFERELIGIBLE:Y") === -1 && this.props.lqState.lqResponse.wirelessPlanType === 'METERED') {
                updateSCTags('upgrade-save5-no thanks');
            } else if (this.props.lqState.vzwOffer.indexOf("VZWBONUSOFFERELIGIBLE:Y") > -1 && this.props.lqState.lqResponse.wirelessPlanType === 'UNLIMITED') {
                updateSCTags('upgrade-save15-no thanks');
            } else if (this.props.lqState.vzwOffer.indexOf("VZWBONUSOFFERELIGIBLE:Y") > -1 && this.props.lqState.lqResponse.wirelessPlanType === 'METERED') {
                updateSCTags('upgrade-save10-no thanks');
            }
        } else {
            if (this.props.lqState.vzwOffer.indexOf("VZWBONUSOFFERELIGIBLE:Y") === -1 && this.props.lqState.lqResponse.wirelessPlanType === 'UNLIMITED') {
                updateSCTags('upgrade-save10-add to cart');
            } else if (this.props.lqState.vzwOffer.indexOf("VZWBONUSOFFERELIGIBLE:Y") === -1 && this.props.lqState.lqResponse.wirelessPlanType === 'METERED') {
                updateSCTags('upgrade-save5-add to cart');
            } else if (this.props.lqState.vzwOffer.indexOf("VZWBONUSOFFERELIGIBLE:Y") > -1 && this.props.lqState.lqResponse.wirelessPlanType === 'UNLIMITED') {
                updateSCTags('upgrade-save15-add to cart');
            } else if (this.props.lqState.vzwOffer.indexOf("VZWBONUSOFFERELIGIBLE:Y") > -1 && this.props.lqState.lqResponse.wirelessPlanType === 'METERED') {
                updateSCTags('upgrade-save10-add to cart');
            }
        }
    }
    buildSCContent = (cta,type,speedCode) => {
        let linkTag ="";
        let upsellProd = "";
        if (this.props.buildProduct.upsell.products.length > 0) {
            if(this.props.buildProduct.upsell && this.props.buildProduct.upsell.oncartkey && 
                this.props.buildProduct.upsell.oncartkey === 'FTTP_1000M_1000M') {
                // upsellProd = "Verizon Home Device Protect";
                // linkTag = `${"upsell " + upsellProd }`;
                linkTag = cta === "ATC" ? "add to cart" : cta === "NT" ? " no thanks" : " close sign";
                updateSCTags(linkTag);
            }
            else if (InHomeUtils.isNotNull(speedCode) && speedCode === "941" && InHomeUtils.isNotNull(this.props.lqState) && InHomeUtils.isNotNull(this.props.lqState.vzwOffer) && this.props.lqState.vzwOffer.indexOf("VZWADVOFFERELIGIBLE:Y") > -1 && InHomeUtils.isNotNull(this.props.lqState.lqResponse) && this.props.lqState.lqResponse.wirelessPlanType) {
                this.updateMnhUpsellSCTags(type);
            }
            else {
                let upsellObject = this.props.buildProduct.upsell.products.filter(product => product.display);
                if(InHomeUtils.isNotEmpty(upsellObject) && upsellObject.length>0 && InHomeUtils.isNotEmpty(upsellObject[0].name)){
                    upsellProd = upsellObject[0].name.toLowerCase();
                }
                // linkTag = `${"upsell " + upsellProd }`;
                // linkTag += cta === "ATC" ? " yes add" : cta === "NT" ? " no" : " close";
                linkTag = cta === "ATC" ? "Add to cart" : cta === "UT" ? "Upgrade Today": cta === "NT"?"no thanks" : "close sign";
                if (InHomeUtils.isNotNull(window.targetupsell) && window.targetupsell === 'Y' && InHomeUtils.isNotNull(window.showupsell) && window.showupsell === 'Y') {
                    if (this.props.buildProduct.upsell && this.props.buildProduct.upsell.oncartkey &&
                        (this.props.buildProduct.upsell.oncartkey === 'FTTP_1000M_1000M:Q9854' || this.props.buildProduct.upsell.oncartkey === 'FTTP_1000M_1000M:R0477')) {
                        linkTag = cta === "NT" ? "no thanks - upsell vzw unlimited" : "close- upsell vzw unlimited";
                    }
                }
                updateSCTags(linkTag);
            }
        }
    }

    processOffers = (offerIDs,showDataOffers, showVideoOffers, showVoiceOffers) => {
        let offers = [];
        let processedOfferIds = [];
        let remainingOfferIds = [];
        let filterOfferIds = offerIDs.filter(offer => showDataOffers && offer.includes('Data') || showVideoOffers && offer.includes('Video') || showVoiceOffers && offer.includes('Voice'));
        let offerIds = [...filterOfferIds].map(offer => offer.split(':')[0]);
        if (InHomeUtils.isNotNull(offerIds) && offerIds.length > 0) {
            offerIds.forEach(offerId => {
                //CASE II-A If case II fails Check for <PromoID>~<OfferID> combination in disclaimerContentFragments
                if (InHomeUtils.isNotNull(this.props.buildProduct.disclaimerContentFragments[offerId]) && InHomeUtils.isNotEmpty(this.props.buildProduct.disclaimerContentFragments[offerId].promoRecommend)) {
                    offers.push(`${offerId}|${this.props.buildProduct.disclaimerContentFragments[offerId].promoRecommend}`);
                    processedOfferIds.push(offerId);
                }
                else if (InHomeUtils.isNotNull(this.props.buildProduct.plansPromoFragments[offerId]) && InHomeUtils.isNotEmpty(this.props.buildProduct.plansPromoFragments[offerId].promo)) {
                    offers.push(`${offerId}|<li>${this.props.buildProduct.plansPromoFragments[offerId].promo}</li>`);
                    processedOfferIds.push(offerId);
                }
                //CASE II-B If case II-A fails Check for <OfferID> combination in disclaimerContentFragments
                else if (offerId.indexOf("~") > -1) {
                    let promoOffer = offerId.split("~")[1];
                    if (InHomeUtils.isNotNull(this.props.buildProduct.disclaimerContentFragments[promoOffer]) && InHomeUtils.isNotNull(this.props.buildProduct.disclaimerContentFragments[promoOffer].promoRecommend)) {
                    offers.push(`${offerId}|${this.props.buildProduct.disclaimerContentFragments[promoOffer].promoRecommend}`);
                    processedOfferIds.push(offerId);
                    }
                }
            });

            offers = offers.filter(o => o !== undefined);
            remainingOfferIds = offerIds.filter(x => !processedOfferIds.includes(x));
            //CASE III If no offer description available then check offersDesc in upsell response
            if ((offers.length === 0 || remainingOfferIds.length) && InHomeUtils.isNotNull(this.props.buildProduct.upsell.offersDesc) && this.props.buildProduct.upsell.offersDesc.length > 0) {
                let offerDesc = [...this.props.buildProduct.upsell.offersDesc];
                // offerDesc = offerDesc.filter(x => remainingOfferIds.indexOf(x.split(':')[0]) > -1);
                offerDesc.forEach(offer => {
                    let promoOfferText = offer.split(":")[1];
                    if(!promoOfferText?.toLowerCase()?.includes('fios setup')) {
                    offers.push(`${offer.split(":")[0]}|<li>${promoOfferText}</li>`);
                    }
                });
            }
        }
        return offers;
    }
    mnhUpsellPriceHandler = () =>{
       let upsellPrice = this.props.buildProduct.upsell.price;
        if (upsellPrice.includes('$0.00')) {
            upsellPrice = "the same price.";
        }
       else if (upsellPrice.includes('.00')) {
            upsellPrice = 'just'+" "+ upsellPrice.replace('.00', '');
        }
        else{
            upsellPrice = 'just'+" "+ upsellPrice; 
        }
        return upsellPrice;
    }
componentDidUpdate (prevProps, prevState) {
    if (this.props.modalWindow.modalId === ModalWindow.ids.upsell) {
                let selectedTvProd = getSelectedTv(this.props.cart.cartResponse, this.props.appState.visitId);
        
                if( !this.props.buildProduct?.suppressInvoke && window.targetupsell === "Y" && this.props.buildProduct?.internet && this.props.buildProduct?.internet?.selectedProduct && this.props.buildProduct?.internet?.selectedProduct?.downSpeed && this.props.buildProduct?.internet?.selectedProduct?.downSpeed === '1024M'  && !(InHomeUtils.isNotNull(this.props.lqState?.lqResponse?.wirelessPlanType)) && InHomeUtils.isNotNull(selectedTvProd) && InHomeUtils.isNotNull(selectedTvProd.prodTypeVal) && (selectedTvProd.prodTypeVal === "ULTIMATETESTDRIVE" || selectedTvProd.prodTypeVal === "ULTIMATE" ) && this.props.lqState?.runtimeKey?.mnhupsell ==='Y') {
                    suppressinter(true,this.props.dispatch);
                    suppressinterinvoke(true,this.props.dispatch);
                }
            }
}
    getsploffercontentCM = (offer, index) => {
        let discountText = offer; 
        return (
           
            <React.Fragment>
                    <div className={!this.isReskin ? "chn-ln-li-upsell" : "listItemBulletRskn"}>
                        {ReactHtmlParser(discountText)}
                    </div>
            </React.Fragment>
        );
    }

    renderSplOfferReskin = (mm3PlanPerks) => {
        try {
            const giftedOffer = this.getSplOfferContent(mm3PlanPerks[0], 0)
            const slicedOffers = mm3PlanPerks?.length > 1 && mm3PlanPerks?.slice(1);
            let remainingOffers = slicedOffers?.map((offer, index) => this.getSplOfferContent(offer, index, true))
            if (remainingOffers?.length > 0) {
                remainingOffers = remainingOffers?.join(", ")
            }
            return <>{giftedOffer}{remainingOffers?.length > 5 && <div className="planFeaturesRskn margin-left-large">Also included on us: {remainingOffers}</div>}</>
        }
        catch (error) {
            console.log(error, "Error in renderSplOfferReskin")
        }
    }

    getSplOfferContent = (offer, index ,   onlyText=false) => {
        const internetSelectedProduct = this.props?.buildProduct?.internet?.selectedProduct;
        const  isClassicalFlow  = !this.props?.buildProductState?.mnFromApi;  
        const displayUpsellModalReskin = this.props?.lqState && this.props?.lqState?.runtimeKey && this.props?.lqState?.runtimeKey?.upsellModalReskin && this.props?.lqState?.runtimeKey?.upsellModalReskin === "Y" && this.props?.appState?.flowType!='MV' && this.props?.appState?.flowType!='SUPP' && !isClassicalFlow ;
        let discountText = "";
        let prefixText = "";
        let suffixText = "";
        if (typeof offer === "string" && offer !== "" && !offer?.includes("eGift Card") &&!offer?.includes("$99 Install Setup Charge Waiver") && !offer?.includes("STARZ app 7 Day Credit") &&!offer?.includes("Fios Setup Discount") && !offer?.includes("$10 Auto Pay")&& (internetSelectedProduct?.name?.includes("100") || internetSelectedProduct?.name?.includes("300") || internetSelectedProduct?.name?.includes("500") || (displayUpsellModalReskin && (internetSelectedProduct?.name?.includes("1 Gig") || this.props?.buildProduct?.upsell?.services?.includes("FDV_VID"))))) {
            if (index === 0 && (offer?.indexOf("HomePod") > -1 || (offer?.indexOf("Verizon Gift") > -1 && !(offer?.indexOf("TV") > -1)) || offer?.indexOf("Amazon") > -1 || offer?.indexOf("Samsung Chromebook") > -1 ||  offer?.indexOf('Xbox Gaming Bundle') > -1)) {
                prefixText = "Choice of: ";
            }
            if (offer?.toUpperCase()?.includes("VIX") && !offer?.toUpperCase()?.includes("BONUS")) {
                prefixText = "Bonus: "
            }
            if (index === 0 && offer?.toUpperCase()?.includes("DISNEY BUNDLE PERK")) {
                suffixText = " (Select Disney Bundle Perk to receive offer)";
            }
            if (offer?.toUpperCase()?.includes("NETFLIX & MAX") && offer?.toUpperCase()?.includes("XBOX GAMING BUNDLE") && offer?.toUpperCase()?.includes("XBOX SERIES S")) {
                discountText = "Netflix & Max (With Ads) for 12 Months or Xbox Gaming Bundle or Xbox Series S, on us";
            } else if (offer?.toUpperCase()?.includes("NETFLIX & MAX") && offer?.toUpperCase()?.includes("XBOX GAMING BUNDLE")) {
                discountText = "Netflix & Max (With Ads) for 12 Months or Xbox Gaming Bundle, on us";
            } else if(offer?.toUpperCase()?.includes("FIOS SETUP DISCOUNT")){
                discountText = "Setup Fee Waiver"
            } else if (displayUpsellModalReskin) {
                discountText = offer?.replace(" - Data", "")?.replace(" - TV", "")?.replace(" - Tv", "")?.replace("(TV)", "");
            } else {
                discountText = offer?.replace(/Get/g, "")?.replace(" - Data", "")?.replace(" - TV", "")?.replace(" - Tv", "");
            }
            if(onlyText){
                return prefixText + discountText + suffixText
            }
            return (
                <React.Fragment>
                    {displayUpsellModalReskin && discountText && discountText?.length > 0 ? <>
                        <div style={{display:"flex"}}><div>
                            <GiftIcon
                                color="#EE0000"
                                size="large"
                                ariaHidden={true}
                            /></div><div className="margin-left-tiny planFeaturesRskn">
                                {prefixText + discountText + suffixText}</div></div></> :
                        <div className={!this.isReskin ? "chn-ln-li-upsell" : "listItemBulletRskn"}>
                            {prefixText + discountText + suffixText}
                        </div>
                    }
                </React.Fragment>
            );
        } else {
            return null;
        }
    }

    getPlanFeatureIcon = (iconName) => {
        switch (iconName) {
            case 'speed-monitoring':
                return (<SpeedMonitoring
                    size="large" color="#EE0000" ariaHidden={true}
                />);
            case 'home-internet':
                return (<HomeInternet
                    size="large" color="#EE0000" ariaHidden="true"
                />);
            case 'download':
                return (<Download
                    size="large" color="#EE0000" ariaHidden="true"
                />);
            case 'lock-closed':
                return (<LockClosed
                    size="large" color="#EE0000" ariaHidden="true"
                />);
            case 'no-fee':
                return (<NoFee
                    size="large" color="#EE0000" ariaHidden="true"
                />);
            case 'tv':
                return (<Tv
                    size="large" color="#EE0000" ariaHidden="true"
                />);
            case 'top-box':
                return (<TopBox
                    size="large" color="#EE0000" ariaHidden="true"
                />);
            case 'cross-device':
                return (<CrossDevice
                    size="large" color="#EE0000" ariaHidden="true"
                />);
            case 'pause':
                return (<Pause
                    size="large" color="#EE0000" ariaHidden="true"
                />);
            case 'find-my-remote':
                return (<FindMyRemote
                    size="large" color="#EE0000" ariaHidden="true"
                />);
        }
    }

    render() {
        let upsellContent = '';
        let offerIds = InHomeUtils.isNotNull(this.props.buildProduct.upsell.offers) ? [...this.props.buildProduct.upsell.offers] : [];
        let offers = [];
        let addlOffers = [];
        let equipOffers = [];
        let allOffers = [];
        let offersToDisplay = [];
        let offerContent = '';
        let displayProd = '';
        let tileImg = '';
        const centerStyle = { textAlign : 'center'};
        let splDataChoiceOffer = [];
        let DataChoiceOffers = [];
        let splBlackFridayOffer = [];
        let splVideoChoiceOffer = [];
        let priceDisplay = true;
        let showDataOffers=false;
        let showVideoOffers=false;
        let showVoiceOffers=false;
        let speedCode = "";
        let upsellHulu = "N";
        let selectedTvProd = getSelectedTv(this.props.cart.cartResponse, this.props.appState.visitId);
        let showmnhupsell = (this.props.buildProduct?.internet && this.props.buildProduct?.internet?.selectedProduct && this.props.buildProduct?.internet?.selectedProduct?.downSpeed && this.props.buildProduct?.internet?.selectedProduct?.downSpeed === '1024M'  && !(InHomeUtils.isNotNull(this.props.lqState?.lqResponse?.wirelessPlanType)) && InHomeUtils.isNotNull(selectedTvProd) && InHomeUtils.isNotNull(selectedTvProd.prodTypeVal) && (selectedTvProd.prodTypeVal === "ULTIMATETESTDRIVE" || selectedTvProd.prodTypeVal === "ULTIMATE" || selectedTvProd.prodTypeVal === "Fios_Five" || selectedTvProd.prodTypeVal === "PREFERRED" ) && this.props.lqState?.runtimeKey?.mnhupsell ==='Y') ? 'Y' : 'N' ;
        // let showprotectTv = (this.props.buildProduct.internet && this.props.buildProduct.internet.selectedProduct && this.props.buildProduct.internet.selectedProduct.downSpeed && this.props.buildProduct.internet.selectedProduct.downSpeed === '1024M' && InHomeUtils.isNotNull(selectedTvProd) && InHomeUtils.isNotNull(selectedTvProd.prodTypeVal) && (selectedTvProd.prodTypeVal === "LOCLDGTL" || selectedTvProd.prodTypeVal === "MUNDO" || selectedTvProd.prodTypeVal === "MUNDO_TOTAL"))? 'Y' : 'N' ;
        let currClient = detectClient();
        let showProtectHome = true;   
        this.isReskin = this.props?.buildProductState?.isReskin && this.props.lqState && this.props.lqState?.runtimeKey && this.props.lqState.runtimeKey?.EnableReskin === 'Y';
        window.showupsell = showmnhupsell;
        //window.targetupsell = "Y"; //Comment this if A/B target is applied
        let upsellid = showmnhupsell === 'N' && showProtectHome && this?.props?.buildProduct?.upsell && this?.props?.buildProduct?.upsell?.oncartkey && this?.props?.buildProduct?.upsell?.oncartkey === 'FTTP_1000M_1000M' && (this?.props?.appState?.flowType !=="MV" || this?.props?.appState?.flowType !=="SUPP") ? ((currClient.deviceType && currClient.deviceType === 'iphone') ? "UpSellModaliPhone" : "UpSellModali") : "";
        let perselectedPerks =  this.props?.cart?.cartData?.length ? this.props?.cart?.cartData[0]?.perks?.perks: [];
        let isHomeDevicePerkAvailable = perselectedPerks?.some(data => data.price === '$25.00' && data.accordionTitle === 'Verizon Home Device Protect')
        if (isHomeDevicePerkAvailable) {
            showProtectHome = false;
        }
        const isMobileView = window.screen.width < 768 ? true : false;
        const  isClassicalFlow  = !this.props?.buildProductState?.mnFromApi;
        const displayUpsellModalReskin = this.props?.lqState && this.props?.lqState?.runtimeKey && this.props?.lqState?.runtimeKey?.upsellModalReskin && this.props?.lqState?.runtimeKey?.upsellModalReskin === "Y" && this.props?.appState?.flowType!='MV' && this.props?.appState?.flowType!='SUPP' && !isClassicalFlow;
        const buttonsGroup = (displayUpsellModalReskin && isMobileView) ? "upsellModalReskinBtn" : (isMobileView) ? "position-sticky flaotingCTA-wrapper flaotingCTAWrapperReskin row margin-top-tiny stickyBottom" : "row margin-top-tiny";
        const hasPerkCredit = this.props.buildProduct?.internet?.m2mPlans?.find?.(p => p?.specialOffers?.some?.(o => o?.OfferText?.toUpperCase?.()?.includes?.("HOME PERK CREDIT")));
        let perkCreditUpsellTxt = "";
        if (hasPerkCredit) {
            let upsellInternet = this.props?.buildProduct?.upsell?.products?.find?.(p => p?.prodType === ProductType.INTERNET_PLAN);
            let upsellInternetName = upsellInternet?.name;
            if (upsellInternetName?.toUpperCase?.()?.includes?.("GIGABIT")) {
                upsellInternetName = upsellInternetName?.includes?.("2") ? "2 Gig" : "1 Gig";
            }
            if (typeof upsellInternetName === "string" && upsellInternetName !== "") {
                perkCreditUpsellTxt = displayUpsellModalReskin ? "Get up to $10/mo credit on any eligible perk." : `Upgrade your plan to ${upsellInternetName} to get up to $10/mo towards an eligible perk.`;
            }
        }
        let isEmberFlow = this.props?.buildProductState?.emberInfo?.isEmberFlow;
        // Function to check if a string contains HTML
        const containsHTMLString = (offer) => {
            const htmlRegex = /<\/?[a-z][\s\S]*>/i;
            return htmlRegex.test(offer);
        }

        const accordionfind= (num,opened)=>{
            switch(num){
                case 1: {
                    if(opened) updateSCTags("Get Repairs or Replacements - expand");
                    else updateSCTags("Get Repairs or Replacements - collapsed");
                    break;
                }
                case 2: {
                    if(opened) updateSCTags("Second Residence Coverage - expand");
                    else updateSCTags("Second Residence Coverage - collapsed");
                    break;
                }
                case 3: {
                    if(opened) updateSCTags("In-Home Expert Visits - expand");
                    else updateSCTags("In-Home Expert Visits - collapsed");
                    break;
                }
                case 4: {
                    if(opened) updateSCTags("24/7 Tech Support - expand");
                    else updateSCTags("24/7 Tech Support - collapsed");
                    break;
                }
                case 5: {
                    if(opened) updateSCTags("Installations Made Easy - expand");
                    else updateSCTags("Installations Made Easy - collapsed");
                    break;
                }
                default:break;
            }
        }
        if (this.props.modalWindow.modalId === ModalWindow.ids.upsell) {
            if(showmnhupsell === 'Y' && InHomeUtils.isNotNull(window.targetupsell) && window.targetupsell === 'Y') {
                upsellContent = (
                    <div>
                        <ModalTitle><Title size="large" viewport={InHomeUtils.getdeviceType()} primitive="h1" color="black">Save more when you switch to Verizon Wireless Unlimited.</Title></ModalTitle>
                        <div className="margin-top-tiny"><Micro viewport="desktop" primitive="h2">Unlimited plans starting at $35/mo with 4 lines on Start Unlimited Plus taxes & fees.</Micro></div>
                        <ModalBody>
                        <Body bold size="large" viewport={InHomeUtils.getdeviceType()} primitive="h2">Mobile + Home Rewards</Body>
                            <div>
                                <p className="chn-ln-li-upsell break-white-space">
                                    <UnorderedList>
                                        <ListItem size="bodyLarge" viewport={InHomeUtils.getdeviceType()}>
                                            Get $15/mo off your Fios bill and $15/mo off your Wireless bill.</ListItem>
                                        <ListItem size="bodyLarge" viewport={InHomeUtils.getdeviceType()}>Earn $5/mo towards your next phone, connected smartwatch or tablet.</ListItem>
                                    </UnorderedList>
                                </p>
                                </div>
                                <Body  size="large" viewport={InHomeUtils.getdeviceType()} primitive="h2">Talk to a Verizon representative to learn more about wireless plans and devices.  Give us your contact information during checkout.  Complete your order and we’ll give you a call within 1 business day.</Body>
                            <div className={buttonsGroup}>
                                <div className="columns tiny-12 small-6 OwnRouterContinue_button margin-bottom-small" style={centerStyle}>
                                    <Button primary width="100%" buttonText="OK please call me" buttonStyle={"button tiny-10 margin-top-tiny"} onClick={e => this.addmnhUpsell()} >OK please call me</Button>
                                </div>
                                <div className="columns tiny-12 small-6 OwnRouterCancel_button" style={centerStyle}>
                                    <Button secondary width="100%" buttonText="No thanks" buttonStyle={"button secondary tiny-10 margin-top-tiny"} onClick={(e) => this.noThanks("NT", '')} >No thanks</Button>
                                </div>
                            </div>
                       </ModalBody>
                    </div>
                )
            }else if(showmnhupsell === 'N' && showProtectHome && this?.props?.buildProduct?.upsell && this?.props?.buildProduct?.upsell?.oncartkey && this?.props?.buildProduct?.upsell?.oncartkey === 'FTTP_1000M_1000M' && (this?.props?.appState?.flowType === "MV" || this?.props?.appState?.flowType === "SUPP")) {
                upsellContent = (
                    <div>
                        <ModalTitle><div  className="ResknModalHeader">Get Verizon Home Device Protect for $25/mo more.</div></ModalTitle>
                        <ModalBody>
                      
                            <div className="modalSubHeaderExtender">Verizon Home Device Protect</div>
                            
                            <div className="marginbottom100" style={{margin:"30px 0px"}}>
                                <h4 class="modalSubHeaderH4Extender">Get Repairs or Replacements</h4>
                                <p>Hassle-free repair or replacement. If your eligible home tech - from TV's, tablets and gaming systems to smart home products, home health care and robotic vacuums - experiences a covered breakdown, we'll repair or replace it for you. Limitations and exclusions apply. See Terms and Conditions before enrollment.</p>  
                                <h4 class="modalSubHeaderH4Extender">Second Residence Coverage</h4>
                                <p>We'll protect eligible home tech not just in your home but in a secondary residence of your choosing.</p>
                                <h4 class="modalSubHeaderH4Extender">In-Home Expert Visits</h4>
                                <p>Two in-home visits every 12 months to get you help with connectivity issues like home tech set-up, and more.</p>
                                <h4 class="modalSubHeaderH4Extender">24/7 Tech Support</h4>
                                <p>Get 1-tap access to experts who can answer virtually any questions about your home tech.</p>
                                <h4 class="modalSubHeaderH4Extender">Installations Made Easy</h4>
                                <p>You can install virtually any piece of home tech for just $49/product (that's a fraction of typical retail installation costs).</p>            

                                    {/* <span tabIndex="0" data-tip data-for="ProtectHomeTip" onClick={this.showToolTip} className="upsell-inner  verizon-icons Icon--info"></span> */}
                                    {/* <ReactTooltip id="ProtectHomeTip" className="upsell_adv_metered" type="light" border="false" place="top" effect="solid" clickable={true} border={true}>
                                        <p><strong>Terms & Conditions</strong></p>
                                        <p>If we determine we cannot service your product as specified in this plan, we may replace it with a replacement product, or we may at our discretion, issue you a gift card or check based on the replacement value, age and condition of the product, as determined by us, immediately prior to the breakdown.</p>
                                    </ReactTooltip> */}
                            </div>
                                
                            <div className={`${buttonsGroup} ${isMobileView ? "" : "vhdUpsellBtnGrp"}`}>
                                <div className={`flaotingCTA columns tiny-12 small-6 OwnRouterContinue_button ${isMobileView ? "margin-bottom-tiny" : ""}`} style={centerStyle}>
                                    <Button primary width="100%" buttonText="Add to Cart" buttonStyle={"button tiny-10 margin-top-tiny"} onClick={e => this.updateSelectedPerk()} >Add to Cart</Button>
                                </div>
                                <div className="flaotingCTA columns tiny-12 small-6 OwnRouterCancel_button" style={centerStyle}>
                                    <Button secondary width="100%" buttonText="No thanks" buttonStyle={"button secondary tiny-10 margin-top-tiny"} onClick={(e) => this.noThanks("NT", '')} >No thanks</Button>
                                </div>                                
                            </div>
                       </ModalBody>
                    </div>
                )
            }
            else if(showmnhupsell === 'N' && showProtectHome && this?.props?.buildProduct?.upsell && this?.props?.buildProduct?.upsell?.oncartkey && this?.props?.buildProduct?.upsell?.oncartkey === 'FTTP_1000M_1000M' && (this?.props?.appState?.flowType !== "MV" || this?.props?.appState?.flowType !== "SUPP")) {
                upsellContent = (
                    <div>
                        <ModalTitle><div  className="ResknModalHeader ResknbackgroundRed">Hassle-free repairs, 24/7 tech support and more. Get Verizon Home Device Protect for less than $1 a day*</div></ModalTitle>
                        <ModalBody>
                            <Accordion type="multi" >
                                <AccordionItem opened="true">
                                    <AccordionHeader onClick={(e,opened) => accordionfind(1,opened)}>
                                    <ConditionIcon color="red" size="large" ariaHidden="true" /><div className="headerDetailfont iconAlign"> Get Repairs or Replacements</div>
                                    </AccordionHeader>
                                    <AccordionDetail>
                                    <div className="subDetailFont">Hassle-free repair or replacement. If your eligible home tech - from TV's, tablets and gaming systems to smart home products, home health care and robotic vacuums - experiences a covered breakdown, we'll repair or replace it for you. Limitations and exclusions apply. See Terms and Conditions before enrollment.</div>
                                    </AccordionDetail>
                                </AccordionItem>
                                <AccordionItem opened="true">   
                                <AccordionHeader onClick={(e,opened) => accordionfind(2,opened)}><SmartCommunities color="red" size="large" ariaHidden="true" /><div className="headerDetailfont iconAlign"> Second Residence Coverage</div></AccordionHeader>
                                    <AccordionDetail>
                                    <div className="subDetailFont">We'll protect eligible home tech not just in your home but in a secondary residence of your choosing.</div>
                                    </AccordionDetail>
                                </AccordionItem>
                                <AccordionItem opened="true">   
                                <AccordionHeader onClick={(e,opened) => accordionfind(3,opened)}><FleetTracking color="red" size="large" ariaHidden="true" /><div className="headerDetailfont iconAlign"> In-Home Expert Visits</div></AccordionHeader>
                                    <AccordionDetail>
                                    <div className="subDetailFont">Two in-home visits every 12 months to get you help with connectivity issues like home tech set-up, and more.</div> 
                                    </AccordionDetail>
                                </AccordionItem>
                                <AccordionItem opened="true">   
                                <AccordionHeader onClick={(e,opened) => accordionfind(4,opened)}><SupportDrawer color="red" size="large" ariaHidden="true" /><div className="headerDetailfont iconAlign"> 24/7 Tech Support</div></AccordionHeader>
                                    <AccordionDetail>
                                    <div className="subDetailFont">Get 1-tap access to experts who can answer virtually any questions about your home tech.</div>
                                    </AccordionDetail>
                                </AccordionItem>
                                <AccordionItem opened="true">   
                                <AccordionHeader onClick={(e,opened) => accordionfind(5,opened)}><Reminder color="red" size="large" ariaHidden="true" /><div className="headerDetailfont iconAlign"> Installations Made Easy</div></AccordionHeader>
                                    <AccordionDetail>
                                    <div className="subDetailFont">Get virtually any piece of home tech installed for just $49/product (that's a fraction of typical retail installation costs).</div>
                                    </AccordionDetail>
                                </AccordionItem>
                                </Accordion>

                                
                            <div className={`${buttonsGroup} ${isMobileView ? "" : "vhdUpsellBtnGrp"}`}>
                                <div className={`columns tiny-12 small-6 OwnRouterContinue_button widthbut ${isMobileView ? "margin-bottom-tiny" : ""}`} style={centerStyle}>
                                    <Button width="100%" buttonText="Add to cart" buttonStyle={"button tiny-10 margin-top-tiny"} onClick={e => this.updateSelectedPerk()} >Add to cart</Button>
                                </div>
                                <div className="columns tiny-12 small-6 OwnRouterCancel_button widthbut" style={centerStyle}>
                                    <Button use="secondary" width="100%" buttonText="No thanks" buttonStyle={"button  tiny-10 margin-top-tiny"} onClick={(e) => this.noThanks("NT", '')} >No thanks</Button>
                                </div>  
                                <div className='pltaxes'>*plus taxes.</div>                              
                            </div>
                       </ModalBody>
                       
                    </div>
                )
            }
            else {
                            // PRODUCT SECTION
            displayProd = this?.props?.buildProduct?.upsell?.products?.map(prod => {
                if (prod?.display) {
                    switch (prod?.prodType) {
                        case ProductType.INTERNET_PLAN: tileImg = <Suspense fallback={<div>loading...</div>}><LazyImage src={images.laptopImage} alt="" className="" /></Suspense>
                        showDataOffers = true;
                        speedCode = prod?.speedCode;
                        break;
                        case (ProductType.TV_BASIC): tileImg = <Suspense fallback={<div>loading...</div>}><LazyImage src={images.tvImage} alt="" className="" /></Suspense>
                        showVideoOffers =true;  
                        break;
                        case (ProductType.TV_BASICDIFF): tileImg = <Suspense fallback={<div>loading...</div>}><LazyImage src={images.tvImage} alt="" className="" /></Suspense>
                        showVideoOffers = true; 
                        priceDisplay = true;
                        break;    
                        case ProductType.VOICE_PRIMARY: tileImg = <Suspense fallback={<div>loading...</div>}><LazyImage src={images.laptopImage} alt="" className="" /></Suspense>
                        showVoiceOffers = true; 
                        break;
                        default: break;

                    }
                    // if(this.props.buildProduct.upsell && this.props.buildProduct.upsell.isnydma && prod['prodType'] && prod['prodType'] === "FVPRIMARY"){
                    //     prod['description'] = "<ul><li>Unlimited local, regional and long-distance calling across the US and to Puerto Rico and Canada, China, Dominican Republic, Hong Kong, India, Mexico, Pakistan, Portugal, Singapore, South Korea and the United Kingdom.</li><li>Over 20 privacy, control and security features included.</li><li>Fiber-optic reliability and incredible sound quality.</li></ul>"
                    //  }
                    return (
                        <div className="row vert-middle margin-vert-zero fluid-grid" key={prod.id}>
                            {/* <div className="column tiny-12 medium-3 padding-vert-zero margin-top-tiny left" style={centerStyle}>{tileImg}</div> */}
                            <div className="column tiny-12 large-12 padding-vert-zero margin-top-tiny left">
                                {displayUpsellModalReskin ? <>
                                    <div className="margin-top-medium">
                                        <Title bold="true"
                                            size={"small"}
                                            primitive={"h3"}
                                            viewport={isMobileView ? "mobile" : "desktop"}>Plan Features</Title>
                                    </div></> : <div className="reskinSubheading">{prod.name}</div>}
                                <span className={`${displayUpsellModalReskin ? "chn-ln-li-upsellRskn" : "chn-ln-li-upsell"} `}>{ReactHtmlParser(prod.description.replace('privacy,','privacy').replace('features can','features you can'))}</span>
                            </div>
                        </div>
                    )
                }
            });
            // OFFER SECTION
            //CASE I If not offers available in case I check for offerids in upsell response
            if (offers.length === 0 && InHomeUtils.isNotNull(offerIds) && offerIds.length > 0) {
                if(InHomeUtils.isNotNull(speedCode) && speedCode ==="941" ){
                    if(this.props.lqState.showStadia ) {
                        let dataOffers = removeUnSelectedManualOffers(offerIds, OfferTypes.GoogleStadia + '_' + OfferTypes.Reward, Service.data, OfferTypes.GoogleStadia + '_' + OfferTypes.Reward);
                        let tvOffers = offerIds.filter(offer => offer.toUpperCase().includes(Service.video))
                        offerIds = [...dataOffers, ...tvOffers];
                        offerIds = offerIds.filter(o => o);
                    }
                    if(this.props.lqState.showMarvel ) {
                        let dataOffers = removeUnSelectedManualOffers(offerIds, OfferTypes.MarvelAvenger + '_' + OfferTypes.SpecialDiscount, Service.data, OfferTypes.MarvelAvenger + '_' + OfferTypes.SpecialDiscount);
                        let tvOffers = offerIds.filter(offer => offer.toUpperCase().includes(Service.video))
                        offerIds = [...dataOffers, ...tvOffers];
                        offerIds = offerIds.filter(o => o);
                    }
                    // if(!this.props.lqState.showMarvel) {
                    //     let dataOffers = action.removeUnSelectedManualOffers(offerIds, OfferTypes.Hulu, Service.data, OfferTypes.Hulu);
                    //     let tvOffers = offerIds.filter(offer => offer.toUpperCase().includes(Service.video))
                    //     offerIds = [...dataOffers, ...tvOffers];
                    //     offerIds = offerIds.filter(o => o);
                    // }
                }
               
            
               
                if(InHomeUtils.isNotNull(speedCode) && speedCode ==="945" ){
                    upsellHulu = "Y";
                }
                 //Filter offers with manual choice and append them with 'or'
                let splOfferDataChoices = offerIds.filter((offer, index) => getOffersFilter(offer, Service.data, index,upsellHulu))
                if(splOfferDataChoices.length > 1) {
                    let splOfferDataId= splOfferDataChoices[0].split('|').length && splOfferDataChoices[0].split('|')[3] || '';
                    let splOfferDataPromoId= splOfferDataChoices[0].split('|').length && splOfferDataChoices[0].split('|')[0] || '';
                    offerIds = removeUnSelectedManualOffers(offerIds, '', Service.data, splOfferDataId);
                    offerIds = offerIds.filter(x => !splOfferDataChoices.includes(x));
                    let splOfferData =this.processOffers(splOfferDataChoices,showDataOffers, showVideoOffers, showVoiceOffers);
                    let blackFridayGNHBSKIP = true;
                    if(splOfferDataChoices[0].includes('NEST_HUBMAX_DATA_BF') || splOfferDataChoices[0].includes('$200_VERIZON_GC_DISCOUNT_BF')){
                        blackFridayGNHBSKIP = false;
                    }
                    if(InHomeUtils.isNotNull(splOfferData) && splOfferData.length && splOfferDataPromoId && blackFridayGNHBSKIP) {
                        splDataChoiceOffer  = splOfferData.filter(o=>o.includes(splOfferDataPromoId.split(':')[0]));
                        if(splDataChoiceOffer && splDataChoiceOffer.length){
                            splDataChoiceOffer = splDataChoiceOffer[0].split('|')[1]
                        }
                        else {
                            splDataChoiceOffer = '';
                        }
                    }
                    let blackDayOffers = splOfferData.map((res) => {
                        let offerTxt = res.split('|')[1];
                        return offerTxt;
                    })
                    String.prototype.allReplace = function (obj) {
                        let retStr = this;
                        for (let x in obj) {
                            retStr = retStr.replace(new RegExp(x, 'g'), obj[x]);
                        }
                        return retStr;
                    };
                    let choiceOfferTxt = "";
                    splOfferData && splOfferData.map((res,index) => {
                        choiceOfferTxt += (index == 0 ? "Choice of: ":" OR ") + res.split('|')[1].allReplace({ '<li>': '', '</li>': '' });
                        return choiceOfferTxt;
                    })
                    DataChoiceOffers = choiceOfferTxt != "" ? `<li>${choiceOfferTxt}</li>` : splDataChoiceOffer;
                    if (InHomeUtils.isNotNull(speedCode) && speedCode === "941" && blackDayOffers && blackDayOffers.length) {
                        let gNHMOffer = false;
                        let vGCOffer = false;
                        let gNHMOfferText = '';
                        let vGCOfferText = '';
                        blackDayOffers.forEach((res) => {
                            if (res.includes("Google Nest Hub Max")) {
                                gNHMOffer = true;
                                gNHMOfferText = res.allReplace({ '<li>': '', '</li>': '' });
                            }
                            else if (res.includes("Verizon Gift Card")) {
                                vGCOffer = true;
                                vGCOfferText = res.allReplace({ '<li>': '', '</li>': '', 'Internet': '' });
                                vGCOfferText = vGCOfferText.replace(/[()]/g, '');
                            }
                        })
                        if (gNHMOffer && vGCOffer) {
                            splBlackFridayOffer = `<li>${gNHMOfferText} or ${vGCOfferText}</li>`
                        }
                    }
                    // for (let i = 0; i < splOfferData.length; i++) {
                    //         splDataChoiceOffer += splOfferData[i].split('|')[1]
                    //     }
                    //splDataChoiceOffer = InHomeUtils.isNotNull(splOfferData)? splOfferData.includes(splOfferDataPromoId): '';
                }
                let splOfferVideoChoices = offerIds.filter((offer, index) => getOffersFilter(offer, Service.video, index))
                if(splOfferVideoChoices.length > 1) {
                    offerIds = offerIds.filter(x => !splOfferVideoChoices.includes(x));
                    splVideoChoiceOffer = this.processOffers(splOfferVideoChoices,showDataOffers, showVideoOffers, showVoiceOffers).join('').replace(/<[/]li><li>/g, ' or ');
                    if(InHomeUtils.isNotNull(splVideoChoiceOffer) && splVideoChoiceOffer.length) {
                        splVideoChoiceOffer  = splVideoChoiceOffer.map(o=>o.split('|')[1]);
                    }
                }
                offers = this.processOffers(offerIds,showDataOffers, showVideoOffers, showVoiceOffers);
                if(InHomeUtils.isNotNull(offers) && offers.length) {
                    offers  = offers.map(o=>o.split('|')[1]);
                }
                if(splVideoChoiceOffer && splVideoChoiceOffer.length) {
                    offers.unshift(splVideoChoiceOffer);
                }
                if(splDataChoiceOffer && splDataChoiceOffer.length) {
                    offers.unshift(DataChoiceOffers);
                }
                if (InHomeUtils.isNotNull(speedCode) && speedCode === "941" && splBlackFridayOffer && splBlackFridayOffer.length) {
                    let findIndex = offers.findIndex((res) => res.includes('AMC+'));
                    if (findIndex !== -1) {
                        offers.splice(++findIndex, 0, splBlackFridayOffer)
                    }
                    else {
                        offers = [...offers, splBlackFridayOffer];
                    }
                }
               
                if (offers && offers.length > 0) {
                    offerContent = ReactHtmlParser(`<b>Plan Extras</b>`);
                }
                offers = [...new Set([...offers])];
            }
            //addlOffers are either static (maintained in upsell config) AND/OR depending on products in cart (i.e free router for 1G)
            if (InHomeUtils.isNotNull(this.props.buildProduct.upsell.addlOffers) && this.props.buildProduct.upsell.addlOffers.length > 0) {
                const addlOffersUnformatted = this.props.buildProduct.upsell.addlOffers;
                const addlOffersFormatted = [...new Set(addlOffersUnformatted)];
                addlOffers = [].concat(...addlOffersFormatted);
                offerContent = ReactHtmlParser(`<b>Plan Extras</b>`);
            }
            //equipmentOffers for FCP
            if (InHomeUtils.isNotNull(this.props.buildProduct.upsell.equipmentOffers) && this.props.buildProduct.upsell.equipmentOffers.length > 0) {
                let equipmentOffers = this.props.buildProduct.upsell.equipmentOffers;
                let filterOfferIds = equipmentOffers.filter(offer => showDataOffers && offer.includes('Data') || showVideoOffers && offer.includes('Video') && !offer.includes('FCP_ROUTER_BHRx_DISCOUNT') || showVoiceOffers && offer.includes('Voice'));
                if (filterOfferIds && filterOfferIds.length > 0) {
                    let equipmentOfferIds = filterOfferIds.map(p => {
                        return p.split('|')[0]
                    });
                    let offers = [];
                    equipmentOfferIds.forEach(offerId => {
                        if (InHomeUtils.isNotNull(this.props.buildProduct.plansPromoFragments[offerId]) && InHomeUtils.isNotEmpty(this.props.buildProduct.plansPromoFragments[offerId].promo)) {
                            offers.push(this.props.buildProduct.plansPromoFragments[offerId].promo);
                        }
                    })
                    offers = offers.filter(o => o !== undefined && o !== null);
                    offers.sort((a, b) => a.toUpperCase().indexOf('INCLUDED') > -1 && b.toUpperCase().indexOf('INCLUDED') === -1 ? 1 : -1)
                    offers = [...new Set(offers)];
                    let equipPromoText = offers.join(" & ");
                    if (InHomeUtils.isNotEmpty(equipPromoText)) {
                        equipOffers.push(`<li>${equipPromoText}${equipPromoText.toUpperCase().indexOf('INCLUDED') === -1 ? ' included' : ''}</li>`);
                    }
                }
            }
            allOffers = [...offers,...addlOffers,...equipOffers]; //Concat both dynamic and static offer arrays
            //offersToDisplay =[...new Set(allOffers)].map(offer => { //Remove duplicate offers after merge
            //allOffers.sort((a,b) => { return a.toUpperCase().includes('BLACK FRIDAY') ? 1 : -1})
            allOffers = allOffers.map(item=>item.replace("Xbox Series S Console On Us","Xbox Series S"));
            let combinedOffer = ""
            offersToDisplay = allOffers.map(offer => {
                if(offer.includes('STARZ ')){
                combinedOffer = offer.replace('STARZ ','Starz | +Play 12 months on us')
                 return ReactHtmlParser(combinedOffer);
                    
                }
                if(this.props.lqState && this.props.lqState.runtimeKey && this.props.lqState.runtimeKey.EnableBlackFridayOffers && this.props.lqState.runtimeKey.EnableBlackFridayOffers === "Y"){
                    if(offer.indexOf("Amazon") > -1){
                        combinedOffer = offer.replace('Black Friday','').slice(0,-5)
                        return
                    }
                    if(offer.indexOf("Verizon GC") > -1){
                        combinedOffer = combinedOffer+" or "+offer.replace('GC (Data) Black Friday','Gift Card').slice(4)
                        return ReactHtmlParser(combinedOffer);
                    }
                }
                if((offer.indexOf("Price Guarantee") == -1 || (!this.props.lqState.isFCPflow && offer.indexOf("Price Guarantee") > -1)) && offer.indexOf("Setup Discount") == -1) { //Price Guarantee should be removed for FCP flow
                    return ReactHtmlParser(offer);
                }
            });

            offersToDisplay = offersToDisplay.filter(o => o !== undefined && o !== null);
            if (InHomeUtils.isNotNull(offersToDisplay) && offersToDisplay.length > 0) {
                offerContent = ReactHtmlParser(`<b>Plan Extras</b>`);
            }
            let mm3PlanPerks = [];
            let cyberMondaymm3PlanPerks = [];
            let mm3Qualified = this.props.buildProduct.internet.mm3Qualified;
            let service_type="";
            let channelInfo = [];
            let featureText = [];
            let filteredPlans =[];
            this?.props?.buildProduct?.upsell?.products?.map((planPerks)=>{
                let specialOffers = planPerks?.specialOffers;
                specialOffers = specialOffers?.filter?.(promo => !promo?.OfferText?.toUpperCase?.()?.includes?.("HOME PERK CREDIT"));
                specialOffers = specialOffers?.map((offer)=>({
                    ...offer,OfferText:offer?.OfferText==="Ray-Ban Meta glasses on us"?"Ray-Ban Meta glasses":offer?.OfferText==="$400 off select Samsung products on us"?"$400 off select Samsung products":offer.OfferText
                }));
                if(planPerks.display){
                   if(planPerks.prodType == "BASIC"){
                    service_type = "Video";
                   }else if(planPerks.prodType == "FTTPD"){
                    service_type = "Data";
                   }
                   channelInfo.push(planPerks.planFeature);

                   if(this.props.lqState && this.props.lqState.runtimeKey && this.props.lqState.runtimeKey.EnableBlackFridayOffers && this.props.lqState.runtimeKey.EnableBlackFridayOffers === "Y"){
                    const combinedValue = specialOffers?.filter?.((item) => item && item?.OfferText && item?.OfferText?.indexOf?.("Black Friday") > -1);
                    const amazonOffer =  ( combinedValue && combinedValue[0] &&combinedValue[0].OfferText.indexOf("Amazon") > -1)?combinedValue[0].OfferText.replace('Black Friday',''):"";
                    const verizongfOffer = ( combinedValue && combinedValue[1] &&combinedValue[1].OfferText.indexOf("Verizon GC") > -1)?combinedValue[1].OfferText.replace('GC (Data) Black Friday','Gift Card'):"";
                    let combo = specialOffers?.filter?.((item) => item && item?.OfferText && item?.OfferText?.indexOf?.("Black Friday") > -1);
                    let exclude = specialOffers?.filter?.((item) => item && item?.OfferText && item?.OfferText?.indexOf?.("Black Friday") == -1);
                    combo && combo.map((item, index) => {
                        if(item.offerFor == service_type && index == 0){
                            mm3PlanPerks.push(amazonOffer +` or `+verizongfOffer);
                      }});
                      exclude && exclude.map((item) => {
                        if(item.offerFor == service_type){
                            mm3PlanPerks.push(item.OfferText);
                      }});      
                   }else if(this.props.lqState && this.props.lqState.runtimeKey && this.props.lqState.runtimeKey.isAllowXboxOffer && this.props.lqState.runtimeKey.isAllowXboxOffer === "Y"){
                    const comboOffer = specialOffers?.filter?.((item) => {  if(item && (item?.OfferText?.indexOf?.("HomePod") > -1 || item?.OfferText?.indexOf?.("Samsung Chromebook") > -1 || item?.OfferText?.indexOf?.("Target") > -1) && item?.OfferText?.indexOf?.("Bonus") == -1) return item });
                    if(comboOffer && comboOffer.length == 2 && comboOffer[0]?.offerFor == service_type){
                        mm3PlanPerks.push(comboOffer[0]?.OfferText+" OR "+comboOffer[1]?.OfferText);
                    }
                    if(comboOffer && comboOffer.length == 3 && comboOffer[0]?.offerFor == service_type){
                        mm3PlanPerks.push(comboOffer[0]?.OfferText+" OR "+comboOffer[1]?.OfferText+" OR "+comboOffer[2]?.OfferText);
                    }
                    // const isNFLComboOffer = planPerks?.specialOffers.filter((item) => {  if(item && (item.OfferText.indexOf("NFL") > -1 || item.OfferText.indexOf("400") > -1)) return item });

                    // if(isNFLComboOffer && isNFLComboOffer.length > 0 && isNFLComboOffer[0]?.offerFor == service_type){
                    //     mm3PlanPerks.push('Choice of '+isNFLComboOffer[0]?.OfferText+" OR "+isNFLComboOffer[1]?.OfferText);
                    // }
                    const hasNintendoAndSamsungOffer = specialOffers?.filter?.(obj=>["FIOS_NINTENDO_SWITCH","FIOS_SAMSUNGAPPLICANCE_HOMEDEPOT"].includes(obj?.BsOfferAttrValue))
                    const Amazon200GCIndex = specialOffers?.findIndex((item)=> ["R4564"].includes(item?.USOCIOSC));
                    const Amazon50GCIndex = specialOffers?.findIndex((item)=> ["R4566"].includes(item?.USOCIOSC));
                    if(hasNintendoAndSamsungOffer?.length===2){
                        const combineOffer = `${hasNintendoAndSamsungOffer[0]?.OfferText} OR ${hasNintendoAndSamsungOffer[1]?.OfferText}` 
                        mm3PlanPerks.push(combineOffer);
                    }
                    let isCyberMondayOffer = specialOffers?.filter(obj=>["R4142","R4140","R4139"].includes(obj?.USOCIOSC));
                    if(isCyberMondayOffer.length>0){
                        let offerAlterTextCM = 'Choice of: Netflix & Max (With Ads) for 12 Months or Xbox Gaming Bundle';
                        cyberMondaymm3PlanPerks.push(offerAlterTextCM);
                        cyberMondaymm3PlanPerks.push("Xbox Series S");
                    }
                    const choiceoffer = specialOffers?.filter?.(spl => spl?.extendedAttributes?.toUpperCase()?.includes("ISCHOICE:YES"))
                    const choiceofferExcluded = specialOffers?.filter?.(spl => !spl?.extendedAttributes?.toUpperCase()?.includes("ISCHOICE:YES"))
                    specialOffers = choiceofferExcluded?.length> 1 ? choiceofferExcluded : specialOffers;
                    let choiceOfferText = '';
                    if(choiceoffer?.length> 1) {
                        choiceOfferText = `Choice of: ${choiceoffer?.map?.(item => item?.OfferText?.replace?.("on us", ""))?.filter(Boolean)?.join(" or ")}`;
                        mm3PlanPerks?.push(choiceOfferText);
                    }

                    let manualOffersText = '';
                    const hasSamsungMetaquestSplOffer = specialOffers?.filter(obj=>obj?.BsOfferAttr === "SPCLDISCOUNT" && obj?.offerFor === service_type &&  ["FIOS_SAMSUNGTV_Q125_PROMO", "FIOS_META_QUEST_3S_HEADSET_Q125_PROMO"]?.includes(obj?.BsOfferAttrValue));
                    if(hasSamsungMetaquestSplOffer?.length===2){
                        const combineOffer = `Choice of: ${hasSamsungMetaquestSplOffer?.[0]?.OfferText?.replace?.("on us", "")} or ${hasSamsungMetaquestSplOffer?.[1]?.OfferText}` 
                        mm3PlanPerks.push(combineOffer);
                    }
                       if (displayUpsellModalReskin) {
                           let hasChoiceOffers = specialOffers?.filter(offer => offer?.extendedAttributes?.toUpperCase()?.includes("ISCHOICE:YES"));
                           if (hasChoiceOffers?.length > 0) {
                               hasChoiceOffers = hasChoiceOffers?.map(offer => offer?.OfferText).join(' or ');
                               mm3PlanPerks.push(`Choice of: ${hasChoiceOffers}`)
                               specialOffers = specialOffers?.filter(offer => !offer?.extendedAttributes?.toUpperCase()?.includes("ISCHOICE:YES"));
                           }
                       }
                    specialOffers?.filter?.((obj) => obj && (obj?.BsOfferAttrValue !== 'NETMAX_PERK_MARKER' && obj?.BsOfferAttrValue !== 'FCP_AUTOPAY_DISCOUNT' && obj?.BsOfferAttrValue != "FIOS_HOMEPOD" && obj?.BsOfferAttrValue != "FIOS_HOLIDAY_ECHOSHOW10"  && obj?.BsOfferAttrValue != "FIOS_XBOX_SERIES_S_ACQ_BF2023" && obj?.BsOfferAttrValue != "FIOS_XBOX_SERIES_S_ACQ_BF2023" && obj?.BsOfferAttrValue?.toUpperCase?.() != "FIOS_SAMSUNGTV_Q125_PROMO" && obj?.BsOfferAttrValue?.toUpperCase?.() != "FIOS_META_QUEST_3S_HEADSET_Q125_PROMO" && obj?.BsOfferAttrValue != "FIOS_CHROMEBKGO_SWAT"  && (obj?.BsOfferAttrValue != "FIOS_SAMSUNGAPPLICANCE_HOMEDEPOT" || obj?.BsOfferAttrValue != "FIOS_NFLSUNTK") && obj?.BsOfferAttrValue !== 'YOUTUBEPREMIUM_PERK_MARKER'))?.map?.((item) => {
                        const excludeCyberMonday = ['R4142', 'R4140', 'R4139'];
                        const excludeVzFwd = ["R3484", "R3668", "R3669", "R3601","R4136", "R4437", "R4071", "R4072"];
                        if(item?.offerFor == service_type && !excludeCyberMonday.includes(item?.USOCIOSC) && !excludeVzFwd.includes(item?.USOCIOSC)) {
                            let offerAlterText = item.OfferText?.replace('Fios Gaming Bundle, on us', 'Xbox Gaming Bundle')?.replace('with the [1 Gig] plan.', '')?.replace('with the [2 Gig] plan.', '')
                            if(['R3883', 'R3884','R3885'].includes(item?.USOCIOSC)){
                                if(item?.USOCIOSC ==="R3883"){
                                    offerAlterText = "$200 Verizon Gift Card";
                                   }
                                   if(item?.USOCIOSC ==="R3884"){
                                    offerAlterText = "$100 Verizon Gift Card";
                                   }
                                   if(item?.USOCIOSC ==="R3885"){
                                    offerAlterText = "$50 Verizon Gift Card";
                                   }
                            }
                           
                            if(item?.offerType !== 'Manual') {
                                // code for swat 211 to show combined text
                                if((item?.USOCIOSC ==="R4564" || item?.USOCIOSC ==="R4566") && Amazon200GCIndex>-1 && Amazon50GCIndex>-1) {
                                    if(item?.USOCIOSC !=="R4566"){
                                        offerAlterText = specialOffers?.[Amazon200GCIndex]?.OfferText + " and a Bonus " + specialOffers?.[Amazon50GCIndex]?.OfferText;
                                        mm3PlanPerks.push(offerAlterText);
                                    }
                                } else {
                                    mm3PlanPerks.push(offerAlterText);
                                }
                            } else {
                                if(manualOffersText?.length > 0) {
                                    manualOffersText += ` or ${offerAlterText}`;
                                } else {
                                    manualOffersText += `${offerAlterText}`;
                                }
                            }
                        }
                    });
                    if(manualOffersText?.length > 0) {
                        mm3PlanPerks.unshift(manualOffersText);
                    }
                }
                   else{
                    const excludeItems = ['R4048', 'Q7734','R4143'];
                    specialOffers?.map?.((item) => {
                        if(item.offerFor == service_type) {
                            let offerAlterText = item.OfferText?.replace('Fios Gaming Bundle', 'Xbox Gaming Bundle');
                            if(['R3883', 'R3884','R3885'].includes(item?.USOCIOSC)){
                                if(item?.USOCIOSC ==="R3883"){
                                    offerAlterText = "$200 Verizon Gift Card";
                                   }
                                   if(item?.USOCIOSC ==="R3884"){
                                    offerAlterText = "$100 Verizon Gift Card";
                                   }
                                   if(item?.USOCIOSC ==="R3885"){
                                    offerAlterText = "$50 Verizon Gift Card";
                                   }
                            }
                            if(excludeItems?.indexOf(item?.USOCIOSC) == -1) {
                                mm3PlanPerks.push(offerAlterText);
                            }
                        }
                    });
                }
                    if(planPerks.prodTypeValue === "ULTIMATETESTDRIVE"){
                        mm3PlanPerks.push("$200 Verizon Gift Card (TV)");
                        featureText.push("Includes MGM+, Showtime & STARZ");
                    }
                }
            });
            let equipPromoFeatures = [];
            if(channelInfo && channelInfo.length > 0){
                equipPromoFeatures.push(channelInfo[0], ...featureText);
                
            }
            let overlayType = (this.props.buildProduct.upsell.header.indexOf("TV") > -1) ? "Video" : (this.props.buildProduct.upsell.header.indexOf("Gigabit") > -1) ? "Data" : ""
                if (mm3Qualified && InHomeUtils.isNotNull(this.props.buildProduct.upsell.equipmentOffers) && this.props.buildProduct.upsell.equipmentOffers.length > 0) {
                    this.props.buildProduct.upsell.equipmentOffers.forEach(offerId => {
                        if(offerId.indexOf(overlayType) > -1){
                            if (offerId.indexOf(":") > -1) {
                                let promoApplicable = offerId.split(":")[0];
                                if (promoApplicable.indexOf(service_type) > -1) {
                                    let promoOffer = offerId.split("|")[0];
                                    if (InHomeUtils.isNotNull(this.props.buildProduct.plansPromoFragments[promoOffer]) && InHomeUtils.isNotNull(this.props.buildProduct.plansPromoFragments[promoOffer].promo)) {
                                        
                                        equipPromoFeatures.push(this.props.buildProduct.plansPromoFragments[promoOffer].promo);
                                    }
                                }
                            }
                        }
                    });
                }
            mm3PlanPerks.push(equipPromoFeatures.filter(a => a.indexOf("TB") > -1)); 
            equipPromoFeatures = equipPromoFeatures.filter(a => a.indexOf("TB") === -1);
            let internetCmsProds = getCmsData()
            let bundleKey = this.props?.buildProduct?.upsell?.bundleKey?.split(':')[0];
            // PRODDEF-40940: The content in Plan Feautres for the More Fios TV should be the upgraded equipment which is The Most Fios TV
            // PRODDEF-40993: The content in Plan Feautres for the Your Fios TV should be the upgraded equipment which is the More Fios TV
            if (
              (this.props?.buildProduct?.upsell?.header || "")
              ?.toLowerCase()?.includes('most fios tv')  ||
              (this.props?.buildProduct?.upsell?.header || "")
              ?.toLowerCase()?.includes('more fios tv') ||
              (displayUpsellModalReskin && this.props?.buildProduct?.upsell?.services?.includes("FDV_DAT") &&  (this.props?.buildProduct?.upsell?.header?.includes("Gig") || this.props?.buildProduct?.upsell?.header?.includes("Gigabit")))
            ) {
              bundleKey =
                this.props?.buildProduct?.upsell?.bundleKey?.split(":")[1];
            }
            const cmsProds = internetCmsProds[bundleKey];  
            let actualRsp = cmsProds && cmsProds?.planDetails ? cmsProds?.planDetails : []
            actualRsp = actualRsp.map(detailResp=> {
                console.log(equipPromoFeatures,"equipPromoFeatures");
                if(detailResp?.includes('|')) {
                    if(mm3PlanPerks.some(perk => perk.includes("Amazon Fire HD")))
                    {
                        if(detailResp.includes("5-Year Price Guarantee"))
                            {
                                return detailResp?.split('|')?.[0]
                            }else{
                                return detailResp?.split('|')?.[1]
                            }
                       
                    }else{
                        return detailResp?.split('|')?.[0]
                    }

                   
                   
                } else {
                    return detailResp
                }
            })   
            if(displayUpsellModalReskin){
                mm3PlanPerks = mm3PlanPerks?.filter(offer=> typeof offer === "string" && offer !== "" && !offer?.includes("eGift Card") && !offer?.includes("$99 Install Setup Charge Waiver") && !offer?.includes("STARZ app 7 Day Credit") && !offer?.includes("Fios Setup Discount") && !offer?.includes("$10 Auto Pay"))
            } 
            equipPromoFeatures = actualRsp?.length > 0 ? actualRsp : equipPromoFeatures
            const equipPlanFeaturesReskin = (cmsProds && cmsProds?.upsellDetails?.length) ? cmsProds?.upsellDetails : (cmsProds && cmsProds?.reviewDetails?.length) ? cmsProds?.reviewDetails : [];
            let specialOffersContent = (!mm3Qualified && !this.props.isMNEnabled) ? (
                <><div className="promo_header_accordion">
                            {offerContent}
                    <span className="chn-ln-li-upsell">
                            <ul>
                                {offersToDisplay.map(offer => <React.Fragment>{offer}</React.Fragment>)} 
                            </ul>
                            </span>
                    </div>
                    {(this.props?.lqState && this.props?.lqState?.runtimeKey && this.props?.lqState?.runtimeKey?.SetupFeeOffer && this.props?.lqState?.runtimeKey?.SetupFeeOffer === "Y" && InHomeUtils.isNotNull(speedCode) && (speedCode === "941" || speedCode === "940")) && 
                    <div className="margin-top-tiny"><Micro viewport="desktop" primitive="span">*Plus taxes</Micro></div>}</>
            ) : (
                    <div>
                        {
                            displayUpsellModalReskin ? <>
                                <React.Fragment>
                                    <div className="margin-top-medium">
                                    <Title id="subHeaderupsell"
                                        bold="true"
                                        size={isMobileView ? "medium" : "large"}
                                        viewport={isMobileView ? "mobile" : "desktop"}>Plan Features</Title>
                                    </div>
                                    <div className="margin-top-tiny">
                                        {equipPlanFeaturesReskin?.length > 0 && equipPlanFeaturesReskin?.map((plan) => (
                                            <>
                                                {plan && plan?.title && plan?.icon && <div className="margin-top-micro" style={{display:"flex"}}><span>
                                                   {this.getPlanFeatureIcon(plan?.icon)}</span>
                                                    <div className="margin-left-tiny planFeaturesRskn">
                                                        {this.props?.buildProduct?.internet?.selectedProduct?.name?.includes("300") && plan?.title.includes("440") ? ReactHtmlParser(plan?.title.replace("440","640")) : ReactHtmlParser(plan?.title) }</div></div>}
                                            </>
                                        ))}
                                    </div>
                                </React.Fragment>
                            </> : <>
                                <div className="promo_header_accordion">
                                    {!this.isReskin && <b>Plan Features</b>}
                                    {this.isReskin && <div className="tvConnReskinCount margin-bottom-tiny">Plan Features</div>}
                                    {equipPromoFeatures.map((offer) => (
                                        <React.Fragment>
                                            {containsHTMLString(offer) ? (
                                                <div
                                                    dangerouslySetInnerHTML={{ __html: offer }}
                                                />
                                            ) : (
                                                <div
                                                    className={
                                                        this.isReskin && offer != ""
                                                            ? "listItemBulletRskn"
                                                            : "chn-ln-li-upsell"
                                                    }
                                                >
                                                    {offer}
                                                </div>
                                            )}
                                        </React.Fragment>
                                    ))}
                                </div></>
                        }
                        
                    <div className="promo_header_accordion" style={{marginTop: '20px'}}>
                            {mm3PlanPerks.length > 1 && !this.isReskin && <b>Special gifts, on us</b>}
                            {mm3PlanPerks.length >= 1 && this.isReskin && <div className="tvConnReskinCount margin-bottom-tiny">{displayUpsellModalReskin ? <Title bold="true" id="subHeaderupsell"
                                size={isMobileView ? "medium" : "large"}
                                viewport={isMobileView ? "mobile" : "desktop"}>{mm3PlanPerks.length === 1 ? "A Special gift, on us" : "Special gifts, on us"}</Title> : "Special gifts, on us"}</div>}
                            {cyberMondaymm3PlanPerks.map((offer, index) => this.getsploffercontentCM(offer, index))}
                            {displayUpsellModalReskin ?  this.renderSplOfferReskin(mm3PlanPerks):  mm3PlanPerks.map((offer, index) => this.getSplOfferContent(offer, index))}

                           
                        </div>
                        {(this.props?.lqState && this.props?.lqState?.runtimeKey && this.props?.lqState?.runtimeKey?.SetupFeeOffer && this.props?.lqState?.runtimeKey?.SetupFeeOffer === "Y" && InHomeUtils.isNotNull(speedCode) && (speedCode === "941" || speedCode === "940")) && !displayUpsellModalReskin && 
                        <div className="margin-top-tiny"><Micro viewport="desktop" primitive="span">*Plus taxes</Micro></div>}</div>
            );
            if(allOffers && allOffers.length ===0){
                specialOffersContent = '';
            }
            let upsellHeaderText = this.props.buildProduct.upsell.header;
            let upsellHeaderSubtxt =this.props.buildProduct?.upsell?.headercontent;
            let upsellPrice = this.props.buildProduct.upsell.price;
            let perkCreditHeaderTxt = '';   
            if (InHomeUtils.isNotEmpty(upsellPrice) && (upsellPrice.includes('the same price') || upsellPrice.includes('$0'))) {
                    upsellPrice = "the same price.";
                    upsellHeaderText = upsellHeaderText.replace('only','')
                }
                else if (InHomeUtils.isNotEmpty(upsellPrice) && upsellPrice.includes('.00')) {
                    upsellPrice = upsellPrice.replace('.00', '/mo*') + (displayUpsellModalReskin ? "" : ".");
                }
                if (InHomeUtils.isNotEmpty(upsellHeaderText) && (upsellHeaderText.includes('Gigabit') || upsellHeaderText?.includes('Get 1 Gig'))) {
                    upsellHeaderText = upsellHeaderText.replace('Gigabit','1 Gig');
                    upsellHeaderText = upsellHeaderText.replace('connection','')
                    if(displayUpsellModalReskin){
                    upsellHeaderText = upsellHeaderText.replace('Get','Upgrade to Fios');
                    upsellHeaderText = upsellHeaderText.replace('only','')
                    if (hasPerkCredit) {
                     perkCreditHeaderTxt = " and save $10/mo"
                    }
                    upsellHeaderSubtxt = "Plus taxes."
                    }
                }
                if (InHomeUtils.isNotEmpty(upsellHeaderText) && upsellHeaderText.includes('Upgrade to 500M')) {
                    upsellHeaderText = upsellHeaderText.replace('Upgrade to 500M Internet for','Get 500M for only');
                }
                if(displayUpsellModalReskin && upsellHeaderSubtxt?.includes("plus equipment")){
                    upsellHeaderSubtxt = upsellHeaderSubtxt.replace('plus equipment','Plus equipment')
                }
                else if (displayUpsellModalReskin && upsellHeaderText?.includes("Fios Home Phone")) {
                    upsellHeaderText = upsellHeaderText.replace("only", "")
                }
            if(!priceDisplay){
               upsellPrice ="";
            }

            let upsellHeaderContent = (
                <React.Fragment>
                    {displayUpsellModalReskin  ? <>
                    <div>
                    <ModalTitle ><div  className="ResknModalHeader ResknbackgroundRed margin-bottom-micro" style={{height:"auto"}}>{upsellHeaderText}{upsellPrice}{perkCreditHeaderTxt}</div></ModalTitle> 
                    <div className={isMobileView ? "margin-top-large" : "margin-top-micro"}><Body id="upsellsubHeader" size = "small" color="#6F7171">
                    {perkCreditUpsellTxt ? `${perkCreditUpsellTxt} ` : ""}{isMobileView && perkCreditUpsellTxt && <br/>} *{upsellHeaderSubtxt} 
                    </Body></div>
                    </div>
                    </> : <>
                        {!this.isReskin && <Title size="large" viewport={InHomeUtils.getdeviceType()} primitive="h2" color="black"><b>{upsellHeaderText}{upsellPrice}</b></Title>}
                        {this.isReskin && <TitleLockup
                            data={{
                                eyebrow: false,
                                title: {
                                    bold: false,
                                    size: 'titleLarge',
                                    children: `${upsellHeaderText}${upsellPrice}`,
                                    primitive: "h2"
                                },
                            }}    
                        />}
                        <div className="margin-top-tiny promo_header_reskin">
                            <span style={{ color: "black" }}>{perkCreditUpsellTxt ? `${perkCreditUpsellTxt} ` : ""} {this.props.buildProduct?.upsell?.headercontent}</span>
                        </div>
                        </>
                  }
                </React.Fragment>
            );
           
            if (InHomeUtils.isNotNull(speedCode) && speedCode === "941" && InHomeUtils.isNotNull(this.props.lqState) && InHomeUtils.isNotNull(this.props.lqState.vzwOffer) && this.props.lqState.vzwOffer.indexOf("VZWADVOFFERELIGIBLE:Y") > -1 && InHomeUtils.isNotNull(this.props.lqState.lqResponse) && this.props.lqState.lqResponse.wirelessPlanType) {
                let upsellSubHeader = this.props.buildProduct.upsell.headercontent;
                if (this.props.lqState.vzwOffer.indexOf("VZWBONUSOFFERELIGIBLE:Y") === -1 && this.props.lqState.lqResponse.wirelessPlanType === 'UNLIMITED' && isEmberFlow !== true) {
                   upsellPrice = this.mnhUpsellPriceHandler();
                    upsellSubHeader = `${this.props.buildProduct.upsell.headercontent} Get $10/mo off your Verizon Wireless bill and $10/mo off your Fios bill with select plans. Enrollment in Verizon Up and Mobile + Home Rewards required after checkout.`;
                    upsellHeaderContent = (
                     <React.Fragment>
                            <Title size="small" viewport={InHomeUtils.getdeviceType()} primitive="h1" color="black">For {upsellPrice.replace('.','')}, get Gigabit Connection and save $20/mo on your bills.</Title>
                            {this.props.lqState&&this.props.lqState.runtimeKey&&this.props.lqState.runtimeKey.EnableMHFiosSignIn&&this.props.lqState.runtimeKey.EnableMHFiosSignIn==="N"&&<div> <div className="margin-top-tiny"><Micro viewport="desktop" primitive="h2">{upsellSubHeader}<span tabIndex="0" data-tip data-for="registerTip"
                                 className="verizon-icons Icon--info"></span></Micro></div>
                         <ReactTooltip id="registerTip" className="upsell_adv_unlimited" type="light" border="false" place="bottom"
                             effect="solid">
                             <p>Verizon Up enrollment and Fios Home internet required. Offer excludes prepaid plans. All discounts apply as long as Verizon provides and you maintain both services and both services remain enrolled in Mobile + Home Rewards. Save $20/mo with Verizon Unlimited and Fios Gigabit Connection plans. $10/mo off mobile and $10/mo off Fios bills. </p>
                         </ReactTooltip></div>}
                     </React.Fragment>
                     )
             } else if (this.props.lqState.vzwOffer.indexOf("VZWBONUSOFFERELIGIBLE:Y") === -1 && this.props.lqState.lqResponse.wirelessPlanType === 'METERED' && isEmberFlow !== true) {
                 upsellPrice = this.mnhUpsellPriceHandler();
                 upsellSubHeader = `${this.props.buildProduct.upsell.headercontent} Get $5/mo off your Verizon Wireless bill and $5/mo off your Fios bill with select plans. Enrollment in Verizon Up and Mobile + Home Rewards required after checkout.`;
                    upsellHeaderContent = (
                     <React.Fragment>
                            <Title size="small" viewport={InHomeUtils.getdeviceType()} primitive="h1" color="black">For {upsellPrice.replace('.','')}, get Gigabit Connection and save $10/mo on your bills.</Title>
                            {this.props.lqState&&this.props.lqState.runtimeKey&&this.props.lqState.runtimeKey.EnableMHFiosSignIn&&this.props.lqState.runtimeKey.EnableMHFiosSignIn==="N"&&<div>
                            <div className="margin-top-tiny"><Micro viewport="desktop" primitive="h2">{upsellSubHeader}<span tabIndex="0" data-tip data-for="registerTip"
                                 className="verizon-icons Icon--info"></span></Micro></div>
                         <ReactTooltip id="registerTip" className="upsell_adv_metered" type="light" border="false" place="bottom"
                             effect="solid">
                             <p>Verizon Up enrollment and Fios Home internet required. Offer excludes prepaid plans. All discounts apply as long as Verizon provides and you maintain both services and both services remain enrolled in Mobile + Home Rewards. Save $10/mo with Verizon Unlimited and Fios Gigabit Connection plans. $5/mo off mobile and $5/mo off Fios bills.</p>
                         </ReactTooltip></div>}
                     </React.Fragment>
                    )
             } else if (this.props.lqState.vzwOffer.indexOf("VZWBONUSOFFERELIGIBLE:Y") > -1 && this.props.lqState.lqResponse.wirelessPlanType === 'UNLIMITED' && isEmberFlow !== true) {
                 upsellPrice = this.mnhUpsellPriceHandler();
                 upsellSubHeader = `${this.props.buildProduct.upsell.headercontent} Get $15/mo off your Verizon Wireless bill and $15/mo off your Fios bill with select plans. Enrollment in Verizon Up and Mobile + Home Rewards required after checkout.`;
                 upsellHeaderContent = (
                     <React.Fragment>
                         <Title size="small" viewport={InHomeUtils.getdeviceType()} primitive="h1" color="black">For {upsellPrice.replace('.','')}, get Gigabit Connection and save $30/mo on your bills.</Title>
                         {this.props.lqState&&this.props.lqState.runtimeKey&&this.props.lqState.runtimeKey.EnableMHFiosSignIn&&this.props.lqState.runtimeKey.EnableMHFiosSignIn==="N"&&<div><div className="margin-top-tiny"><Micro viewport="desktop" primitive="h2">{upsellSubHeader}<span tabIndex="0" data-tip data-for="registerTip"
                                 className="verizon-icons Icon--info"></span></Micro></div>
                         <ReactTooltip id="registerTip" className="upsell_bonous_unlimited" type="light" border="false" place="bottom"
                             effect="solid">
                            <p>Verizon Up enrollment and Fios Home internet required. Offer excludes prepaid plans. All discounts apply as long as Verizon provides and you maintain both services and both services remain enrolled in Mobile + Home Rewards. Save $30/mo with Verizon Unlimited and Fios Gigabit Connection plans. $15/mo off mobile and $15/mo off Fios bills. Credit is provided as device dollars that expire if unused within 24 months of issuance date.</p>
                         </ReactTooltip></div>}
                     </React.Fragment>
                 )
             } else if (this.props.lqState.vzwOffer.indexOf("VZWBONUSOFFERELIGIBLE:Y") > -1 && this.props.lqState.lqResponse.wirelessPlanType === 'METERED' && isEmberFlow !== true) {
                 upsellPrice = this.mnhUpsellPriceHandler();
                 upsellSubHeader = `${this.props.buildProduct.upsell.headercontent} Get $10/mo off your Verizon Wireless bill and $10/mo off your Fios bill with select plans. Enrollment in Verizon Up and Mobile + Home Rewards required after checkout.`;
                 upsellHeaderContent = (
                     <React.Fragment>
                        <Title size="small" viewport={InHomeUtils.getdeviceType()} primitive="h1" color="black">For {upsellPrice.replace('.','')}, get Gigabit Connection and save $20/mo on your bills.</Title>
                        {this.props.lqState&&this.props.lqState.runtimeKey&&this.props.lqState.runtimeKey.EnableMHFiosSignIn&&this.props.lqState.runtimeKey.EnableMHFiosSignIn==="N"&&<div><div className="margin-top-tiny"><Micro viewport="desktop" primitive="h2">{upsellSubHeader}<span tabIndex="0" data-tip data-for="registerTip"
                                 className="verizon-icons Icon--info"></span></Micro></div>
                         <ReactTooltip id="registerTip" className="upsell_bonous_metered" type="light" border="false" place="bottom"
                             effect="solid">
                             <p>Verizon Up enrollment and Fios Home internet required. Offer excludes prepaid plans. All discounts apply as long as Verizon provides and you maintain both services and both services remain enrolled in Mobile + Home Rewards. Save $20/mo with Verizon Unlimited and Fios Gigabit Connection plans. $10/mo off mobile and $10/mo off Fios bills. Credit is provided as device dollars that expire if unused within 24 months of issuance date.</p>
                         </ReactTooltip></div>}
                     </React.Fragment>
                     )
             }
                }
                
                /**
                 * 
                 * <div className="modal_header z_index_change" >
                            <ModalTitle>
                        {upsellHeaderContent}</ModalTitle>
                    </div>


                    <div className="modal_content fixModalHeight"> </div>

                        <p>
                            <b>{this.props.buildProduct.upsell.subheader}</b>
                        </p>
                 */
                
                upsellContent = (
                    <div>
                        <div>{upsellHeaderContent}</div>
                       <ModalBody>
                       {specialOffersContent}
                         <div>{mm3Qualified && displayProd}</div>
                         <div>{upsellHeaderText.indexOf("Fios Home Phone") > -1 && displayProd}</div> 
                         {displayUpsellModalReskin && !isMobileView && <div className="margin-top-small"><Line type="secondary"/></div>}
                            <div className={`${buttonsGroup} ${!isMobileView?"btn-row":""}  ${displayUpsellModalReskin && !isMobileView &&  "appfbHeaderAlignment vhdUpsellBtnGrp"} `}>
                            <div className={`${(isMobileView || !displayUpsellModalReskin)   ? "": "columns"} tiny-12 medium-6 large-6 OwnRouterContinue_button margin-bottom-tiny buttonTxtsize`} style={centerStyle}>
                                <Button width="100%" primary buttonText="Add to Cart"  onClick={e => this.addUpsellToCart(showDataOffers, showVideoOffers, showVoiceOffers, speedCode)} >{ (upsellHeaderText?.indexOf("Fios Home Phone") > -1 ||  !displayUpsellModalReskin)? "Add to Cart": 'Upgrade today'}</Button>
                            </div>
                            <div className={`${displayUpsellModalReskin ? "" : "columns"} tiny-12 medium-6 large-6 OwnRouterCancel_button buttonTxtsize`} style={centerStyle}>
                                <Button width="100%" use ={displayUpsellModalReskin ? "secondary" :"primary"} buttonText="No thanks"  onClick={(e) => this.noThanks("NT", speedCode)} >No thanks</Button>
                            </div>
                        </div>
                        </ModalBody>
                </div>
            )
            }
        }

        return (
            <ModalOverlay id={upsellid} className="vzicon small text-black middle" template={upsellContent} noThanks={(e) => this.noThanks('',speedCode)} modalWindow={this.props.modalWindow} dispatch={this.props.dispatch}></ModalOverlay>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        lqState: state.loopQual,
        buildProductState: state.buildProduct,
    }
}

export default connect(
    mapStateToProps
)(upsell);
''